import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { Menu, X, Mountain } from "lucide-react";

export default function Header() {
  const { lang, toggleLang, t } = useLang();
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  return (
    <header
      data-testid="header-nav"
      className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <button
          data-testid="logo-btn"
          onClick={() => scrollTo("hero")}
          className="flex items-center gap-2 group"
        >
          <Mountain className="w-7 h-7 text-[#FF3B30] transition-transform group-hover:-translate-y-0.5" />
          <span className="font-heading text-xl tracking-[0.15em] text-white">
            LNMA
          </span>
        </button>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            ["programs", t.nav.programs],
            ["team", t.nav.team],
            ["forms", t.nav.contact],
          ].map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-${id}`}
              onClick={() => scrollTo(id)}
              className="text-sm uppercase tracking-[0.15em] text-[#A3A3A3] hover:text-white transition-colors font-body"
            >
              {label}
            </button>
          ))}

          {/* Language Toggle */}
          <button
            data-testid="lang-toggle"
            onClick={toggleLang}
            className="text-xs uppercase tracking-[0.2em] border border-[#262626] px-3 py-1.5 text-[#A3A3A3] hover:border-[#FF3B30] hover:text-white transition-colors font-body"
          >
            {lang === "en" ? "ES" : "EN"}
          </button>

          {/* CTA */}
          <button
            data-testid="nav-apply-btn"
            onClick={() => scrollTo("forms")}
            className="bg-[#FF3B30] text-white font-heading uppercase tracking-widest text-sm px-6 py-2 hover:bg-[#FF5C53] transition-colors"
          >
            {t.nav.apply}
          </button>
        </nav>

        {/* Mobile Hamburger */}
        <button
          data-testid="mobile-menu-btn"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-white"
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Overlay */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu-overlay"
          className="md:hidden fixed inset-0 top-16 bg-[#0A0A0A]/95 backdrop-blur-xl flex flex-col items-center justify-center gap-8 z-40"
        >
          {[
            ["programs", t.nav.programs],
            ["team", t.nav.team],
            ["forms", t.nav.contact],
          ].map(([id, label]) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              className="font-heading text-3xl uppercase tracking-wider text-white hover:text-[#FF3B30] transition-colors"
            >
              {label}
            </button>
          ))}
          <button
            onClick={toggleLang}
            className="text-sm uppercase tracking-[0.2em] border border-[#262626] px-4 py-2 text-[#A3A3A3] hover:border-[#FF3B30] hover:text-white transition-colors font-body"
          >
            {lang === "en" ? "Espanol" : "English"}
          </button>
          <button
            onClick={() => scrollTo("forms")}
            className="bg-[#FF3B30] text-white font-heading uppercase tracking-widest text-lg px-8 py-3 hover:bg-[#FF5C53] transition-colors"
          >
            {t.nav.apply}
          </button>
        </div>
      )}
    </header>
  );
}
